<template>
  <div id="app"  style="position: absolute;">
      <router-view name="header"></router-view>
      <main style="height: 100%; padding-bottom:0px">
        <fade-transition origin="center" mode="out-in" :duration="350">
          <router-view/>
        </fade-transition>
      </main>
      <footer style="background-color: #05141f; color: white; padding: 20px 0;">
        <router-view name="footer"></router-view>
      </footer>
      
    
  </div>
</template>

<script>
import {FadeTransition} from "vue2-transitions";

export default {
  name: "personaliza",
  components: {
    FadeTransition
  }
}
</script>

<style scoped>



footer {
  background-color: #05141f !important;
  color: white;
  padding: 20px 0;
  text-align: center;
  width: 100%;
  position: relative;
}
</style>
